import ServicoSearchHeader from './ServicoSearchHeader';

export default ServicoSearchHeader;
